// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n    .competencyField:hover {\n        cursor: pointer;\n    }\n    ", "",{"version":3,"sources":["webpack://./src/pages/assessment/assess-referee/competency-points-component.ts"],"names":[],"mappings":";IACI;QACI,eAAe;IACnB","sourcesContent":["\n    .competencyField:hover {\n        cursor: pointer;\n    }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
